import classes from './PageTitle.module.css'

const PageTitle = ({children, isContainer, isInTab}) => {
    return <div className={`${classes.page_title_container} ${isContainer ? classes.is_container : ''}`}>
        {!isInTab && <h1>{children}</h1>}
        {isInTab && <h2>{children}</h2>}
    </div>
}

export default PageTitle